module.exports = __webpack_public_path__ + "img/2_1-residenziale-edicola-0.5f9eac27.png";